export const DeductibleSI = [25000, 50000, 100000, 200000, 300000, 500000 ]
export const CriticalIllnessMinMaxRange = {
  "minValue": 10000,
  "maxValue": 20000000,
  "intvl" : 10000
}
export const CriticalIllnessPlanType =[
    {
      "PLANCode": "PLAN1",
      "PLAN_Description": "9  CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    },
    {
      "PLANCode": "PLAN2",
      "PLAN_Description": "12 CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    },
    {
      "PLANCode": "PLAN3",
      "PLAN_Description": "15 CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    },
    {
      "PLANCode": "PLAN4",
      "PLAN_Description": "18 CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    },
    {
      "PLANCode": "PLAN5",
      "PLAN_Description": "25 CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    },
    {
      "PLANCode": "PLAN6",
      "PLAN_Description": "40 CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    },
    {
      "PLANCode": "PLAN7",
      "PLAN_Description": "51 CriticalIllnesses covered",
      "AddonCover Type": "Critical Illness",
      "SumInsured": "Sum Insured should be  between 1Lakh to 2 Crore in multiple of 1000."
    }
  ]

  export const HospitalCashAddonCover_SumInsured = [500,1000 , 1500 , 2000 ]

export const opWellbeing_regions: string[] = [
  'MUMBAI', 'NAVI MUMBAI', 'THANE', 'DELHI', 'GURGAON', 'GURUGRAM', 'BANGLORE', 'BANGALURU',
  'HYDERABAD', 'PUNE', 'GHAZIABAD', 'JAIPUR', 'KOLKATA', 'LUCKNOW', 'CHENNAI', 'INDORE',
  'NAGPUR', 'BHOPAL', 'ALLAHABAD', 'VARANASI', 'PATNA', 'JODHPUR', 'RAIPUR', 'CHANDIGARH',
  'KARIM NAGAR', 'NIZAMABAD', 'MYSORE', 'COIMBATORE', 'NELLORE', 'PANCHKULA', 'RANCHI',
  'VISAKHAPATNAM', 'SOLAPUR', 'NAVSARI', 'KOLHAPUR', 'MADURAI', 'KURNOOL', 'MOHALI', 'ERODE',
  'VIJAYAWADA', 'KASHIPUR', 'KAKINADA', 'NORTH 24 PARGANAS', 'SOUTH 24 PARGANAS',
  '24 NORTH PARGANAS', '24 SOUTH PARGANAS', 'KHARGONE', 'KRISHNA', 'RAJARHAT', 'SALTLAKE', 'NEWTOWN'
];

export const HDFCnominee =["Spouse", "Brother", "Child", "Daughter",
"Employee",
"Father",
"Father in law",
"Grand Daughter",
"Grand Father",
"Grand Mother",
"Grand Son",
"Husband",
"Mother",
"Mother in law",
"Partner",
"Policy Holder",
"Sister",
"Son",
"Special concession adult",
"Special concession child",
"Wife"
]
